import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona con niños con mucha personalidad?',
    a: 'Sí, especialmente con niños de "voluntad fuerte". El método se basa en conexión antes que corrección, lo cual reduce la resistencia natural de los niños con carácter fuerte.'
  }, {
    q: '¿Tengo que imprimirlo?',
    a: 'No es obligatorio, se lee perfecto desde el celular, tablet o computadora. Aunque incluimos un tracker que puedes imprimir si prefieres llevar el registro en papel.'
  }, {
    q: '¿Qué pasa si un día grito?',
    a: 'El plan incluye una sección de reparación para volver al sistema. Somos humanos, el objetivo no es la perfección, sino tener herramientas para reconectar cuando nos equivocamos.'
  }, {
    q: '¿Es muy largo?',
    a: 'No, está diseñado para padres sin tiempo. Las lecturas diarias te tomarán aproximadamente 10 minutos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 max-w-3xl mx-auto" data-id="element-37">
      <FadeIn data-id="element-38">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-[#2D2A26] mb-10" data-id="element-39">
          Preguntas Frecuentes
        </h2>
      </FadeIn>

      <div className="space-y-4" data-id="element-40">
        {faqs.map((faq, index) => <FadeIn key={index} delay={index * 100} data-id="element-41">
            <div className={`bg-white rounded-2xl border transition-all duration-300 overflow-hidden ${openIndex === index ? 'border-[#E8604C]/30 shadow-md' : 'border-[#2D2A26]/10 shadow-sm hover:border-[#E8604C]/20'}`} data-id="element-42">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-43">
                <span className="font-serif font-bold text-lg text-[#2D2A26] pr-4" data-id="element-44">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#E8604C] transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-45" />
              </button>

              <div className={`transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-46">
                <p className="p-6 pt-0 font-sans text-[#2D2A26]/80 leading-relaxed" data-id="element-47">
                  {faq.a}
                </p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}